
const presetSettings = { 
    dayNum: 3,
    hourNum: 13,
    startHour: 9,
    startDate: new Date(2021, 4, 7)
  };


export default presetSettings;